import { Section } from './../argument/argument.model';
import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { DataGridService } from './data-grid.service';
import { ExportService } from 'src/app/_services/export.service';
import { QueryStates } from './../query.reducer';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as actions from './../query.actions';
import { LazyLoadEvent } from 'primeng/api';

@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrls: ['./data-grid.component.scss']
})
export class DataGridComponent implements OnInit , OnDestroy{

  display = false;
  @Input() typeViewData = ''; //maint, sec
  @Input() gridData;
  @Input() queryIdSelected; // id - Nombre Query Seleccionada
  @Input() queryconfigtype = '';
  @Input() graphreport;
  @Input() paginationflag; //bandera  de paginacion
  emptynulldate = ''; /// setear valores para campos date
  exportpdfflag = ''; /// setear valores para campos date
  exportxlsflag = ''; /// setear valores para campos date
  consultEject  = '';


  @Input() arguments = []
  totalList: number = 0;
  argumentosPendientes: any[] = [];  // aplica a subquery, argumentos requeridos pendiente por ingresar
  argumentosSubQuery: any[] = [];  // aplica a subquery, argumentos totales
  sections: any[] = [];

  columns: any [] = []; // InfoColumnas  {title: "", field: "RowIndex" , align: "right", datatype: "RowIndex", locked: true, pdf: true, width: 50
  public columnsHeaders: any [] = [];
  public isExistColumnsHeaders: boolean = false;
  gridView: any [] = []; // origen de datos de la grid
  headers: any [] = []; // origen de datos de la grid

  existsHeaders: boolean = false;
  existsFormSubQuery: boolean = false;

  showGrid = false;  // determina si se muestra la grilla o no
  // Paginacion
  selectedRow; // fila seleccionada
  firstRowTable = 0;
  paginatorList = false;
  rowsList = 50 ;
  //
  largeText = ''; // texto largo
  title = ''; // title modal
  //
  scrollHeight = '';
  //
  fileNameExport = 'Unknow';

  @ViewChild('mdOptions') mdOptions: ModalDirective;

  subscriptionProcessStore: Subscription;
  subscriptionDataGrid: Subscription;
  subscriptionDataSubGrid: Subscription;



  queryid: string = "";
  basedonid: string = "" ;
  queryHeader: string = "" ;
  basedOnHeaderId: string = "" ;

  submitted = false;
  displayRpt = false;
  displayMacroConfig = false;
  reportLocation = "";
  queryidExportMacro: string = "";
  displayMacro:boolean = false
  argumentsExportMacro:any[] = [];
  optionReportSelected: any =  {queryColumnId: 'null' };

  displayRptQuery:boolean = false;

  flagInmediateExecute = true;
  firstLoadDataTable = true;


  form: FormGroup;

  constructor( private activatedRoute: ActivatedRoute,
               private dataGridService: DataGridService,
               private exportService: ExportService,
               private store: Store<QueryStates>,
               public spinner: NgxSpinnerService,
               private toastr: ToastrService) {
                /*this.subscriptionProcessStore = this.store.select('processQueryState').subscribe(stateProcess => {
                  this.processStateManage(stateProcess);
              });*/
               }

  ngOnInit() {
   // // console.log('Iniciando data grid')
    this.displayRpt = false;
    this.scrollHeight =  window.innerHeight > 700 ?  (window.innerHeight - 250) + 'px' : '300px';
    /// // console.log('Tamaño ventana: ' + this.scrollHeight,  window.innerHeight)

    // se coloca la subcripcion en init porque en contructor aun no se contaba con el valor de la propiedad typeViewData
    if (this.typeViewData === 'maint'){
        // aplica solo a vantanas principales
        this.subscriptionProcessStore = this.store.select('processQueryState').subscribe(stateProcess => {
            this.processStateManage(stateProcess);
        });
    } else { // this.typeViewData == 'sec' // ventana secundaria
       this.flagInmediateExecute = true;
       this.showGrid = true;
       this.rowsList = 20 ;

       let optionmenu = this.activatedRoute.snapshot.params['optionmenu'];
       this.queryid = this.activatedRoute.snapshot.params['queryid'];
       this.basedonid = this.activatedRoute.snapshot.params['basedonid'];
       this.queryHeader = this.activatedRoute.snapshot.params['queryHeader'];
       this.basedOnHeaderId = this.activatedRoute.snapshot.params['basedOnHeaderId'];

       // // console.log('Info Header ' + this.queryHeader  + ' ' + this.basedOnHeaderId )

       this.dataGridService.getScenarios(this.queryid, this.basedonid)
       .subscribe( (responseScenario: any[]) => {
        // // console.log('Escenarios SEC QUERY' , responseScenario );
        this.sections = responseScenario[0].sections;
        this.argumentosSubQuery = [];
        this.reportLocation =  responseScenario[0].reportlocation;
        this.queryconfigtype =  responseScenario[0].queryconfigtype;
        this.emptynulldate =  responseScenario[0].emptynulldate;
        this.exportxlsflag =  responseScenario[0].exportxlsflag;
        this.exportpdfflag =  responseScenario[0].exportpdfflag;
        this.consultEject = 'Y';
        this.onloadFormSubQuery(this.sections); /// crear cntroles del form
        // // console.log("LOCATION SUB: ", this.reportLocation);
        for (const section of this.sections) {
          for (const items of section.args) {
            // argumentos = {...argumentos , ...items.group }
            this.argumentosSubQuery.push (...items.group);
        }
      }

        // // // console.log('Lista argumentos del escenario' , this.argumentosSubQuery );
        // // // console.log('Lista argumentos recibidos', this.arguments);
        this.argumentosPendientes = [];
        for  (const arg of this.argumentosSubQuery){
          let argumento = '[' + arg.argid + ']';
          let argFind = this.arguments.find(item => item.argid === argumento ) ;
          let postArg = this.arguments.indexOf(argFind);
          if (postArg < 0) {
            // arg.argid = '[' + arg.argid + ']';
            this.argumentosPendientes.push('[' + arg.argid + ']');
            // existen requeridos pendientes / se solicitan al  usuario

            if (this.flagInmediateExecute && arg.required === 'true' ) {
              this.flagInmediateExecute = false ;
            }

          } else {
            // console.log('Valor de parametro existente: ', argFind );
            argFind = this.formatArgumentDateString(argFind);
            this.form.controls[arg.argid].setValue(argFind.argdata);
          }
        }

        // console.log('Lista argumentos pendientes: Total: ' + this.argumentosPendientes.length , this.argumentosPendientes);

        if (this.flagInmediateExecute ) {
            this.executeSubQuery();
          // this.loadSubGridData(this.queryid, this.basedonid, this.queryHeader, this.basedOnHeaderId );
        }

      }, err => {
        this.toastr.error('Error consulta de escenarios: ' +  err);
        this.spinner.hide();
        // console.log('Error consulta de escenarios: ', err);
      });
    }
  }

  async onloadFormSubQuery(sections: Section[]) {
    // console.log('Estado  existsFormSubQuery' , this.existsFormSubQuery);
    await this.onToFormGroup(sections);
    // console.log('Estado Formulario Subquery' , this.form );
    this.existsFormSubQuery = true;
    // console.log('Estado despues existsFormSubQuery' , this.existsFormSubQuery);
  }

  onToFormGroup(sections: Section[]) {
    // inicializar fomrulario con los argumentos de la seccion seleccionada
    return new Promise(resolve => {
      this.form = this.dataGridService.onToFormGroup(sections);
      return resolve(true);
    });
  }

  openPage(options: any) {
    // https://www.oodlestechnologies.com/blogs/Open-popup-window-with-http-POST-data-Javascript/
    // query/subquery/ReporteRequest/RFX3B3B500000098 ,  TITULO
    // const popup = window.open(`/#/query/subquery/${queryid}/${basedonid}/${queryColumnId}/${value}`, value,
    //  'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=0,
    // resizable=0,width=screen.width,height=screen.height,top=100px,left=100px')

    // var myWindow =  window.open("", "_blank", "width=200,height=100", false);
    // myWindow.document.write("<p>This is 'MsgWindow'. I am 200px wide and 100px tall!</p>   Last name: <input type='text' name='lname' value='Remberto'>");

    //// Solucion columnas con el mismo nombre del padre
    let tempArgs = Object.assign([], this.arguments );
    let arrdata = [];

    let argFind = tempArgs.find(item => item.argid === options.queryColumnId ) ;
    let postArg = tempArgs.indexOf(argFind);
    if (postArg < 0) {
        // console.log('El argumento link NO se encontro' , options.queryColumnId )
        arrdata = [ ...tempArgs , {
        argid : `${options.queryColumnId}`,
        argdesc : '',
        argdata : options.value+"",
        argtext : options.value+"",
        argtype: 'string'
      }]

    } else {
      // console.log('El argumento link SI se encontro' , options.queryColumnId )
      //argFind.argdesc = '';
      //argFind.argdata = options.value+"";
      //argFind.argtext = options.value+"";
      //argFind.argtype = 'string';
      arrdata = [ ...tempArgs];
    }

    const nameWindow =  JSON.stringify({
      idkey : `ventana:` + new Date().toString() ,
      data : arrdata
    });

    // console.log('Lista Original de argumentos', this.arguments)
    // console.log('Lista enviada de argumentos a subquery', arrdata)

    /*
    const nameWindow =  JSON.stringify({
      idkey : `ventana:` + new Date().toString() ,
      data : [ ...this.arguments ,{
        argid : `${options.queryColumnId}`,
        argdesc : '',
        argdata : options.value+"",
        argtext : options.value+"",
        argtype: 'string'
      }]
    });*/

     // // console.log(nameWindow)
    let screenWidth  =  window.innerWidth * 0.8  /// 80%
    let screenHeight  =  window.innerHeight * 0.8  /// 80%

    let queryHeader = options.queryHeader == null ? 'NA': options.queryHeader  ;
    let basedOnHeaderId = options.basedOnHeaderId  == null ? 'NA': options.basedOnHeaderId ;

    /*let popup = window.open(
      `/#/queries/subquery/${options.queryid}/${options.basedonid}/${options.queryColumnId}/${options.value}/${queryHeader}/${basedOnHeaderId}`,
     nameWindow,
     `toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=yes,width=${screenWidth},height=700, left=200` , false
   );*/

   let refColValue = options.value+"";
   refColValue = refColValue.replace("/", "3!B");

   let popup = window.open(
    `/#/labviewer/sub/queries/subquery/${options.queryid}/${options.basedonid}/${options.queryColumnId}/${refColValue}/${queryHeader}/${basedOnHeaderId}`,
   nameWindow,
   `toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=yes,width=${screenWidth},height=700, left=200` , false
 );
  }

  processStateManage(stateProcess){
    this.showGrid = true;
    switch (stateProcess.stateProcess) {
      case 'Initial':
          this.showGrid = false;
          break;
      case 'Invalid':
          this.showGrid = false;
          break;
      case 'Set Section':
          this.showGrid = false;
          break;
      case 'Execute':
        this.arguments = stateProcess.options.args;
        this.queryid = stateProcess.options.queryid;
        this.basedonid = stateProcess.options.basedonid;
        this.firstRowTable = 0; // inicializar apuntador de la tabla
        this.firstLoadDataTable = true; // bandera para controlar 1a ejecucion de datos. Sino se ejecuta por el evento lazyload de la tabla
        this.loadGridData(this.queryid, this.basedonid, 0 , this.rowsList );
        break;
      case 'Execute Reports Macro':
        // console.log('Informacion tipo pantalla' , this.typeViewData)
        this.queryidExportMacro = stateProcess.options.queryid;
        this.argumentsExportMacro = stateProcess.options.args;
        this.reportLocation = stateProcess.options.reportlocation;
        if(this.queryidExportMacro === 'CaractGeoquimicaFast' ||
          this.queryidExportMacro === 'CaracterizacionCrudos' ||
          this.queryidExportMacro === 'HistoricoCrudos2' ||
          this.queryidExportMacro === 'HistoricoGeoquimica'){
          this.displayMacroConfig = true;
        }else{
          if(this.valMacros(this.queryidExportMacro) === false) {
            this.displayMacro = true;
          } else {
            this.displayRptQuery = true;
          }
        }

        break;
      default:
        break;
    }
  }

  exportMacroConfig(queryid){
    this.spinner.show();
    this.dataGridService.onGetExportMacroConfig(queryid).subscribe(res =>{
      this.exportService.executeReport(res, 'xlsm', queryid);
      this.spinner.hide();
    }, err => {
      this.toastr.error("Error al exportar")
      this.spinner.hide();
      // console.log('Error ejecucion exprtacion: ', err);
    });
  }

  downloadFilePdf(documentId){
    let objectDocumentId: any = {
      "documentId": documentId
  }
    this.spinner.show();
    this.dataGridService.onGetExportHistPdf(objectDocumentId).subscribe(res =>{
      this.exportService.executeReport(res, 'pdfHist', documentId);
      this.spinner.hide();
    }, err => {
      this.toastr.error("Error al descargar archivo")
      this.spinner.hide();
      // console.log('Error ejecucion descarga: ', err);
    });
  }




  valMacros(queryid){
    if(queryid === 'RepBiotecnologiaCombinado'){
      return false;
    }else if(queryid === 'HISTORICO DETALLE SUBMISSION'){
      return false;
    }else{
      return true;
    }
  }

  loadGridData(queryid , basedonid, skip, take){
    console.log("Argumentos loadGridData", this.arguments);
    this.gridView = []; // limpiar datos de la grilla
    if(this.paginationflag==='N'){
      skip = 0;
      take = 0;
    }
    let valSpecial: boolean = this.validarSpecial(queryid);
    if(!valSpecial){
      this.spinner.show();
      this.subscriptionDataGrid = this.dataGridService.onGetDataGrid(queryid,basedonid,this.arguments,
            this.queryconfigtype,'','', skip, take)
      .subscribe ((res: any[]) => {
        try {
            // console.log("datos recibidos de la query: " , res);
            this.gridData = res;  ///
            this.gridView = res['data'];
            this.firstLoadDataTable = false;
            if (res['data'].length > 0) {
              if (this.queryconfigtype ==='procedure'){
                res['header']=[];
                this.columns = this.mapConfig(res['config']); // configuracion de columnas cuando es procedimiento
                this.store.dispatch(actions.setProcessState({stateProcess: 'config-grafic',
                options: {
                  columns:this.columns,
                  queryId: queryid,
                  basedOnId: basedonid,
                  queryConfigType: this.queryconfigtype,
                  arguments: this.arguments
                }}));
              }else{
                this.columns = res['config'];// configuracion de columnas
                this.store.dispatch(actions.setProcessState({stateProcess: 'config-grafic',
                options: {
                  columns:this.columns,
                  queryId: queryid,
                  basedOnId: basedonid,
                  queryConfigType: this.queryconfigtype,
                  arguments: this.arguments
                }}));
              }

              let columnHeader = this.columns.find(element => element.columnHeader !== null && element.columnHeader !== '');

              if (columnHeader !== undefined && columnHeader !== null) {
                this.isExistColumnsHeaders = true;

                let columnHeaderActual: any = {value: '', position: 0, width: 0};
                let columnHeaderWidth: any [] = [];

                this.columns = this.columns.map((value, indice, array) => {
                  if (value.columnHeader !== null &&  value.columnHeader !== '') {
                    if (columnHeaderActual.value !== value.columnHeader) {
                      if (columnHeaderActual.width > 0) {
                        columnHeaderWidth.push({position: columnHeaderActual.position, width: columnHeaderActual.width});
                      }
                      columnHeaderActual = { value: value.columnHeader, position: indice};
                      columnHeaderActual.width = 1;

                      if (this.columns.length-1 === indice) {
                        columnHeaderWidth.push({position: columnHeaderActual.position, width: columnHeaderActual.width});
                      }
                    } else {
                      columnHeaderActual.width++;
                      if (this.columns.length-1 === indice) {
                        columnHeaderWidth.push({position: columnHeaderActual.position, width: columnHeaderActual.width});
                      }
                    }

                  }
                  return value;
                });

                let position: number = 0;
                columnHeaderWidth.forEach((value, indice)=> {
                  if (value.position === position) {
                    this.columnsHeaders.push({ width: value.width, columnHeader: this.columns[value.position].columnHeader });
                    position = value.position + value.width;
                  } else if (position < value.position) {
                    this.columnsHeaders.push({ width: value.position - position, columnHeader: '' });
                    this.columnsHeaders.push({ width: value.width, columnHeader: this.columns[value.position].columnHeader });
                    position = position + (value.position - position) + value.width;
                  }
                });


              }

              // this.rowsList = 20;
              this.paginatorList = (res['data'].length > this.rowsList) ? true : false;
              // console.log('Valor Paginacion total registros', res['regPaginaList'][0].cantReg)
              this.totalList = res['regPaginaList'][0].cantReg;
              if(this.totalList === null){
                this.totalList = this.gridView.length;
              }
              if(this.graphreport === 'Y'){
                this.store.dispatch(actions.setProcessState({stateProcess: 'Data Grafic' ,
                options: {
                  data: this.gridView
                }}));
              }
              this.showGrid = true;
              this.spinner.hide();
            } else {
              this.spinner.hide();
            }
        } catch (error) {
          this.toastr.error(`Error:  ${error}`);
          this.spinner.hide();
        }
      },
      err => {
        // console.log('Error en respuesta' , err );
        this.showGrid = true;
        if(err.error.message === 'El query no registra información según los parámetros enviados'){
          this.gridData = null;
          this.gridView = [];
        }else if(err.error.message === 'No message available'){
          this.gridData = null;
          this.gridView = [];
          this.showGrid = true;
        }else{
          this.toastr.error(`Error:  ${err.error.message}`);
          this.gridData = null;
          this.gridView = [];
        }
        this.spinner.hide();
      })
    }
  }

  async exportMacro(queryid){
    this.spinner.show();
    if(queryid === "" || queryid === undefined){
      queryid = this.queryid;
    }
    if(this.argumentsExportMacro === null || this.argumentsExportMacro === undefined){
      this.argumentsExportMacro =  Object.assign ([], this.arguments);
    }else if(this.argumentsExportMacro.length === 0){
      this.argumentsExportMacro =  Object.assign ([], this.arguments);
    }
    let args =  null;
    // console.log("Argumentos Iniciales special: ", this.arguments);
    if(this.argumentosPendientes.length > 0){
      if (this.valFormValidArgs()) {
        await this.setDefaultValueArgsForms (this.sections);
        this.submitted = false;
        args =  Object.assign ([], this.arguments);
        this.dataGridService.onGetDataMacro(queryid,args)
        .subscribe (res =>{
          this.exportService.executeReport(res, 'xls', queryid);
          this.spinner.hide();
        });
       }  else {
        this.submitted = true;
       }
    } else {
      await this.setDefaultValueArgsForms (this.sections);
      // console.log("Argumntos Finales special: ", this.argumentsExportMacro);
      args =  Object.assign ([],this.argumentsExportMacro);
      for (let arg of args) {
        arg = this.formatArgumentDateString(arg);
      }
      this.dataGridService.onGetDataMacro(queryid,args)
      .subscribe (async res => {
        const resExport = await this.exportService.executeReport(res, 'xls', queryid);
        this.spinner.hide();
        this.displayMacro = false;
      },
      err => {
          this.toastr.error(`Error en exportación de datos:  ${err.error}`);
          // console.log('Error ejecucion servicio: ', err);
          this.spinner.hide();
      });
    }
  }

  loadSubGridData(queryid , basedonid, queryHeader, basedOnHeaderId, skip, take){
    let valSpecial: boolean = this.validarSpecial(queryid);
    if(!valSpecial){
      this.spinner.show();
      // console.log('ejecutar servicio de consulta de datos SubQuery', this.arguments);
      this.subscriptionDataSubGrid = this.dataGridService.onGetDataGrid(
            queryid, basedonid, this.arguments , this.queryconfigtype, queryHeader, basedOnHeaderId, skip, take)
      .subscribe ((res: any[]) => {
        try {
            // console.log('datos recibidos servicio SubQuery' , res);
            this.gridData = res;  ///
            this.gridView = res['data'];
            this.firstLoadDataTable = false;
            this.totalList = res['regPaginaList'][0].cantReg;

            this.columns = res['config'];  // configuracion de columnas
            this.store.dispatch(actions.setProcessState({stateProcess: 'config-grafic',
            options: {
              columns:this.columns,
              queryId: queryid,
              basedOnId: basedonid,
              queryConfigType: this.queryconfigtype,
              arguments: this.arguments
            }}));
            this.headers = res['header'];

            if (this.headers !== null) {
              this.existsHeaders = this.headers.length > 0 ? true : false;
            } else {
              this.existsHeaders = false;
            }

            this.paginatorList = (res['data'].length > this.rowsList) ? true : false;
            this.spinner.hide();
        } catch (error) {
          this.toastr.error(`Error:  ${error}`);
          this.spinner.hide();
        }
      },
      err => {
        if(err.error.message === 'El query no registra información según los parámetros enviados'){
          this.gridData = null;
          this.gridView = [];
          this.showGrid = true;
        }else if(err.error.message === 'No message available'){
          this.gridData = null;
          this.gridView = [];
          this.showGrid = true;
        }else{
          this.toastr.error(`Error:  ${err.error.message}`);
          this.gridData = null;
          this.gridView = [];
          this.showGrid = true;
        }
        // console.log('Error ejecucion servicio: ', err);
        this.spinner.hide();
      })
    }
  }

  openLargeText(title, largeText){
    if(largeText){
      this.mdOptions.show();
      this.largeText = largeText;
      this.title = title;
    }
  }
  onCancelModal(){
    this.mdOptions.hide();
  }

  onGenerateDocumentXlsx(format) {
    let arrArgs = this.arguments.map(item => {
      let rObj = {}
      rObj[item.argid] = item.argtext
      return rObj
   })
    const options = {
      fileName : this.queryIdSelected,
      typeFormat: format,  // XLSX   CSV
      title : {
              label: String(this.queryIdSelected).toUpperCase() ,
              font: '{ "name": "Calibri", "family": 4, "size": 16, "bold": true }',
              height: 60
              },
      subtitle : {
                label: 'Generado: ' + (new Date()).toString(),
                font: '{ "name": "Calibri", "family": 4, "size": 9, "color": "blue" }',
                height: 12
                },
      header: {
        label:   this.columns.map(({title}) => (title)) , // [ "Col 1", "Col 2", "Col 3" ] ,
        sizeCols: this.columns.map(({width}) => (20))  /// por defecto 20,podria utilizar el mismo ancho que viene en la configuracion
      },
      dataArgs : arrArgs ,
      data : [] ,
      dataJson: this.gridView,
    };
    this.exportService.generateReport(options);
  }

async executeSubQuery(){
  this.consultEject = 'Y';
  if (this.valFormValidArgs()) {
    await this.setDefaultValueArgsForms (this.sections);
    this.submitted = false;
    this.loadSubGridData(this.queryid, this.basedonid, this.queryHeader, this.basedOnHeaderId, 0 , this.rowsList);
   } else {
    this.submitted = true;
   }
}

valFormValidArgs() {
  // Valida si el formulario con los argumentos es valido y emite mensaje
  if (!this.form.valid) {
    this.toastr.warning("Existen argumentos requeridos no ingresados.",'Validación Argumentos')
    return false;
  }
  return true;
}




  setDefaultValueArgsForms(sections) {
    return new Promise (resolve=> {
      let _listArguments: any [] = [] ;
      for (const section of sections){
       for (const items of section.args){
           for (const arg of items.group) {

             if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt')  && this.form.value[arg.argid].length === 0 )  {
                this.form.value[arg.argid] = 'null';
              }
             if (typeof (this.form.value[arg.argid]) === 'object' && (arg.argtype !== 'dateonly' && arg.argtype !== 'absreldt')) {
                  let arrElementsString = '';
                  let totalElements = 0;
                  if (this.form.value[arg.argid].length) {
                    for (const element of this.form.value[arg.argid]){
                      if (totalElements > 0) {
                        arrElementsString = arrElementsString + `,`;
                      }
                      arrElementsString = arrElementsString + `'${element.value}'`;
                      totalElements += 1;
                    }
                  } else {
                    arrElementsString = this.form.value[arg.argid].value;
                  }
                  this.form.value[arg.argid] = arrElementsString;
              }
            //  if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt') && this.form.value[arg.argid].length > 0)  {
            //     this.form.value[arg.argid] = this.intlService.formatDate(this.form.value[arg.argid]);
            //   }

             let argument: any = {
              argid : `[${arg.argid}]`,
              argdesc : arg.argdesc,
              argdata : this.form.value[arg.argid],
              argtext : this.form.value[arg.argid],
              argtype : arg.argtype
              };
             _listArguments.push(argument);
           }
         }
      }
      // // console.log('Valores Formulario' , this.form.value);
      this.arguments = _listArguments ;
      // console.log('Valores calculados' , _listArguments  );
      resolve(0);
    })

  }

  mapConfig(config){
    return config ; /*
    return config.map((item) => ({
      fieldsqueryid: item.fieldsqueryid,
      fieldQueryDesc: item.fieldQueryDesc,
      configqueryid: item.configqueryid,
      fieldName: item.fieldName,
      title: item.title,
      fieldOrder: item.fieldOrder,
      filterable: item.filterable,
      field: item.fieldName, //Se colocó igual al fieldName
      datatype: item.datatype,
      queryid: item.queryid,
      queryColumnId: item.queryColumnId,
      fileIco: item.fileIco,
      rptLocation: item.rptLocation,
      showColumn: item.showColumn,
      width: item.width,
      pdf: item.pdf,
      excel: item.excel,
      columnHeader: item.columnHeader,
      showRowFieldExcel: item.showRowFieldExcel,
      queryHeader: item.queryHeader,
      basedOnHeaderId: item.basedOnHeaderId,
      basedOnId: item.basedOnId,
      locked: item.locked,
      align: item.align,
      ico: item.ico,
      stylecolumn: item.stylecolumn
      }));*/
  }

  formatArgumentDateString( arg){
      if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt') && arg.argdata !== 'null') {
         // // console.log("es fecha->" + arg.argdata, new Date(arg.argdata))
          let date = null;
          let day = "";
          let month = "";
          // console.log("Mes: ", arg.argdesc, " :", new Date(arg.argdata).getMonth());
          if (new Date(arg.argdata).getDate() < 10) {
            day = '0' + new Date(arg.argdata).getDate();
          }
          if (new Date(arg.argdata).getMonth() +1 < 10) {
            month = '0' + (new Date(arg.argdata).getMonth() + 1);
          }
          date = new Date(arg.argdata);
          arg.argdata = `${day !== "" ? day : new Date(arg.argdata).getDate()}/${month !== "" ? month : new Date(arg.argdata).getMonth() + 1}/${new Date(arg.argdata).getFullYear()}`;
          arg.argtext = arg.argdata;
          arg.argtype === 'string';
      }
      if ((arg.argtype === 'dateonly' || arg.argtype === 'absreldt') && arg.argdata === 'null') {
        // console.log('validacion EMPTY NULL DATE', this.emptynulldate )
        if (this.emptynulldate === 'Y') {
          arg.argdata = '';
        }
      }
      return arg;
  }


  exportTamplate(format){
      this.spinner.show();
      // console.log("ANTES: ", this.arguments);
      let args: any [] =  Object.assign ([], this.arguments);
      for (let arg of args) {
        arg = this.formatArgumentDateString(arg);
      }
      let objectReportTemplate = {
        "format": format,
        "reportname": this.queryid,
        "queryId": this.queryid,
        "basedonId": this.basedonid,
        "encabezado": this.headers,
        "level": 1,
        "arguments": args
      }
      objectReportTemplate.arguments = this.objectLogoName(objectReportTemplate.arguments);
      objectReportTemplate.arguments = objectReportTemplate.arguments.map((item) => ({
        name: item.argid === undefined ? "" : item.argid,
        title: item.argdesc === undefined ? "" : item.argdesc,
        value: item.argdata === undefined ? "" : item.argdata,
        text: item.argtext === undefined ? "" : item.argtext,
      }));
      this.dataGridService.onGetJasperTemplate(objectReportTemplate).subscribe(res =>{
        this.exportService.executeReport(res, format, this.queryid);
        this.spinner.hide();
      }, err => {
        this.toastr.error("Error al exportar")
        this.spinner.hide();
        // console.log('Error ejecucion exprtacion: ', err);
      });
      // console.log("DESPUES: ", this.arguments);
    }

    changeDisplayRpt(options: any){
      this.reportLocation = options.location;
      this.optionReportSelected = options;
      this.displayRpt = true;
    }

    exportJasperQuery(format){
      // console.log('Lista Argumentos Export OnlyJasper', this.arguments )
      this.spinner.show();
      let listArgumentsJasper: any[] = [];
      let map = new Map<string, string>();
      let jsonObject = {};
      this.arguments.forEach(argQuery => {
        let arg =  Object.assign ({}, argQuery);
        arg = this.formatArgumentDateString(arg);
        listArgumentsJasper.push(arg);
      });
      listArgumentsJasper.forEach(element => {
        let valorArg = Object.assign ({}, element);
        valorArg.argid = valorArg.argid.replace("[", "").replace("]", "");
        jsonObject[valorArg.argid] = valorArg.argdata;
      });
      this.dataGridService.onGetJasper(this.reportLocation, jsonObject, format, this.queryidExportMacro).subscribe(res =>{
        let arrLocationReport = this.reportLocation.split("/");
        let nameReport = arrLocationReport[2];
        // console.log("NOMBRE REPORTE: ", nameReport);
        this.exportService.executeReport(res, format, nameReport);
        this.spinner.hide();
        this.displayRpt = false;
      }, err => {
        this.toastr.error("Error al exportar")
        this.spinner.hide();
        this.displayRpt = false;
      });

      this.optionReportSelected = {queryColumnId: 'null' }; // iniciarlizar valores
    }

    exportOnlyJasper(format){
      // console.log('Lista Argumentos Export OnlyJasper', this.arguments )
      this.spinner.show();
      let map = new Map<string, string>();
      let jsonObject = {};
      ////
      let tempArgs = Object.assign([], this.arguments );
      let arrdata = [];

      if (this.optionReportSelected.queryColumnId === 'null' ) {
        arrdata = [ ...tempArgs];
      } else {
        let argFind = tempArgs.find(item => item.argid === this.optionReportSelected.queryColumnId ) ;
        let postArg = tempArgs.indexOf(argFind);
        if (postArg < 0) {
            // console.log('El argumento link NO se encontro' , this.optionReportSelected.queryColumnId )
            arrdata = [ ...tempArgs , {
            argid : `${this.optionReportSelected.queryColumnId}`,
            argdesc : '',
            argdata : this.optionReportSelected.value + "" ,
            argtext : this.optionReportSelected.value,
            argtype: 'string'
          }]
        } else {
          // console.log('El argumento link SI se encontro' , this.optionReportSelected.queryColumnId )
          argFind.argdesc = '';
          argFind.argdata = this.optionReportSelected.value;
          argFind.argtext = this.optionReportSelected.value;
          argFind.argtype = 'string';
          arrdata = [ ...tempArgs];
        }
      }
      ///
      arrdata.forEach(element => {
        let valorArg = Object.assign ({}, element);
        valorArg.argid = valorArg.argid.replace("[", "").replace("]", "");
        jsonObject[valorArg.argid] = this.formatArgumentDateString(valorArg).argdata;
      });
      this.dataGridService.onGetJasper(this.reportLocation, jsonObject, format, this.queryid).subscribe(res =>{
        let arrLocationReport = this.reportLocation.split("/");
        let nameReport = arrLocationReport[2];
        // console.log("NOMBRE REPORTE: ", nameReport);
        this.exportService.executeReport(res, format, nameReport);
        this.spinner.hide();
        this.displayRpt = false;
      }, err => {
        this.toastr.error("Error al exportar")
        this.spinner.hide();
        this.displayRpt = false;
      });

      this.optionReportSelected = {queryColumnId: 'null' }; // iniciarlizar valores
    }


    validarSpecial(queryId){
      if(queryId == 'ReporteTest'){
        return true;
      }else if(queryId === 'ReporteRequest'){
        return true;
      }else if(queryId === 'RPTE_SUBMISSION_HIST_JAS'){
        return true;
      }else if(queryId === 'ReporteXMuestra'){
        return true;
      }else if(queryId === 'ReporteXMuestraHist'){
        return true;
      }else{
        return false;
      }
    }

    downloadFile(fileName){
      //fileName='RPT_Alrt_Cali_Ve_Lab.pdf:200720211163:InformeRequ:3';
      this.spinner.show();
      let arrayFileName: any [] = fileName.split(":");
      let objectRequest = {
        "keyid": arrayFileName[1],
        "sdcid": arrayFileName[2],
        "attachmentnum": arrayFileName[3]
      }
      this.dataGridService.onDownloadFile(objectRequest).subscribe((res: any) =>{
        let dataType = res.type;
        let binaryData = [];
        let downloadLink = document.createElement('a');

        binaryData.push(res);
        downloadLink.href = window.URL.createObjectURL(new Blob (binaryData, {type: dataType}));
        if(arrayFileName[0]){
          downloadLink.setAttribute('download', arrayFileName[0]);
        }
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.spinner.hide();
      }, err => {
        this.toastr.error("Error en la descarga")
        this.spinner.hide();
      });
    }

    downloadFileICP(fileName){
      //fileName='RPT_Alrt_Cali_Ve_Lab.pdf:200720211163:InformeRequ:3';
      this.spinner.show();
      let arrayFileName: any [] = fileName.split(":");
      let objectRequest = {
        "keyid": arrayFileName[1],
        "sdcid": arrayFileName[2],
        "attachmentnum": arrayFileName[3]
      }
      this.dataGridService.onDownloadFileICP(objectRequest).subscribe((res: any) =>{
        let dataType = res.type;
        let binaryData = [];
        let downloadLink = document.createElement('a');

        binaryData.push(res);
        downloadLink.href = window.URL.createObjectURL(new Blob (binaryData, {type: dataType}));
        if(arrayFileName[0]){
          downloadLink.setAttribute('download', arrayFileName[0]);
        }
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.spinner.hide();
      }, err => {
        this.toastr.error("Error en la descarga")
        this.spinner.hide();
      });
    }

    ngOnDestroy() {
      if (this.subscriptionProcessStore){
        this.subscriptionProcessStore.unsubscribe();
      }
      if (this.subscriptionDataGrid) {
        this.subscriptionDataGrid.unsubscribe();
      }
      if(this.subscriptionDataSubGrid) {
        this.subscriptionDataSubGrid.unsubscribe();
      }
    }
    objectLogoName(args){

      let logoName = {
        "argdata":sessionStorage.getItem('logonName'),
        "argtext": sessionStorage.getItem('logonName'),
        "argid": "[LOGON_NAME]",
        "argdesc": "Usuario",
        "argtype": "string"
      }
      let sysUserId = {
        "argdata":sessionStorage.getItem('sysUserId'),
        "argtext": sessionStorage.getItem('sysUserId'),
        "argid": "[SYSUSERID]",
        "argdesc": "sysUserId",
        "argtype": "string"
      }
      args.push(logoName);
      args.push(sysUserId);
      return args;
    }

    loadTableData(event: LazyLoadEvent) {
        // // console.log('Evento Lazy: ' +  this.firstRowTable  + ' ' + this.firstLoadDataTable ,  JSON.stringify(event));
        if (!this.firstLoadDataTable) {
          // si no se coloca la bandera, el evento se ejecuta al construir la tabla
          this.loadGridData(this.queryid, this.basedonid, event.first , event.rows);
        };
      }
    public formatStyle(style: string) {
      return  JSON.parse(style) ;
    }

    async onVewPanelGraphic(){
      // // console.log("Entro data grid");
      this.store.dispatch(actions.setProcessState({stateProcess: 'Vew Panel Graphic' , options: {}}));
    }
}
